import React, { createContext, useContext } from 'react';

import { useTestCaseFilter } from './TestCaseFilter.hook';

export type TestCaseFilterContextValue = ReturnType<typeof useTestCaseFilter>;

export const initialContextValue: TestCaseFilterContextValue = {
  textSearchFilter: '',
  assigneeFilter: [],
  statusFilter: [],
  testTypeFilter: [],
  isTestCaseFilterActive: false,
  filterTestCaseFunction: () => false,
  setTextSearchFilter: () => undefined,
  setAssigneeFilter: () => undefined,
  setStatusFilter: () => undefined,
  setTestTypeFilter: () => undefined,
};

export const TestCaseFilterContext =
  createContext<TestCaseFilterContextValue>(initialContextValue);

export const useTestCaseFilterContext = (): TestCaseFilterContextValue => {
  const value = useContext(TestCaseFilterContext);

  if (!value) {
    throw new Error('TestCaseFilterContext used outside the provider!');
  }

  return value;
};

type Props = { children: React.ReactNode };

export default function TestCaseFilterProvider({
  children,
}: Props): JSX.Element {
  const value = useTestCaseFilter();

  return (
    <TestCaseFilterContext.Provider value={value}>
      {children}
    </TestCaseFilterContext.Provider>
  );
}
